import React from 'react'
import Events from './events/Events'
// import Gallery from './gallery/Gallery'
import Gallery2 from './gallery/gallery2'

export default function Page4(){
  return (
    <div>
        <Events />
        {/* <Gallery /> */}
        <Gallery2 />

    </div>
  )
}
